import { PricingItemTypeEnum } from '../../pricing-items/enums/pricing-item-type.enum';
import type { PricingItemTotalsInput } from '../interfaces/pricing-item-totals-input.interface';
import type { NetTaxGrossTotals } from '../types/net-tax-gross-totals.type';

const zeroTotals = (): NetTaxGrossTotals => ({ net: 0, tax: 0, gross: 0 });

/**
 * Aggregates pricing items by discountability. STANDARD is discountable; all
 * other types are non-discountable.
 */
export function partitionPricingItemsByDiscountability(
  items: PricingItemTotalsInput[] | null | undefined,
  discountableType: PricingItemTypeEnum = PricingItemTypeEnum.STANDARD,
): {
  discountable: NetTaxGrossTotals;
  nonDiscountable: NetTaxGrossTotals;
} {
  return (items ?? []).reduce(
    (acc, item) => {
      const bucket =
        item.type === discountableType ? acc.discountable : acc.nonDiscountable;

      bucket.net += Number(item.unitsTotalNet ?? 0);
      bucket.tax += Number(item.unitsTotalTax ?? 0);
      bucket.gross += Number(item.unitsTotalGross ?? 0);

      return acc;
    },
    {
      discountable: zeroTotals(),
      nonDiscountable: zeroTotals(),
    },
  );
}
